import React, { useEffect, useState } from "react";
import { Link,useNavigate, useOutletContext } from "react-router-dom";
import GameSvcCtntCtxtApi from "Apis/GameSvcCtntCtxtApi";
import TrmsLstInqApi from "Apis/TrmsLstInqApi";
import MgpStore from "Stores/Store";
import CommuBrdPstdCmntApi from "Apis/CommuBrdPstdCmntApi";
import GamePageBanner from "Components/GamePageBanner";
import CommuCmntUi from "Views/Commu/CommuCmntUi";
import "Assets/css/Trms.css";
import "Assets/css/Ctnt.css";
import { useLocation } from "react-router-dom";
import ApiResultModal from "Components/ApiResultModal";
import CommuCmntWriteUi from "./CommuCmntWriteUi";
import CommuBrdPstdCtntApi from "Apis/CommuBrdPstdCtntApi";
import { CommuCategoryNode } from "Views/Commu/CommuCategoryAccordionMenu";
import CommuCategoryLayout from "Views/Commu/CommuCategoryLayout";
import CommuBrdCtgrLstApi from "Apis/CommuBrdCtgrLstApi";

interface CommuBrdCtgrNode extends CommuCategoryNode {
    subCtgrCd?: string;
    prntCtgrCd: string | null;
    children: CommuBrdCtgrNode[];
}

const DUMMY_POST_DATA = {
    brdPstdTitl: "[임시] 커뮤니티 게시글 안내",
    crtdDtime: "2026-08-20 10:00:00",
    brdPstdReadCnt: 0,
    brdPstdCtxt: "<p>게시글 조회 API 오류로 인해 임시 더미 데이터를 표시하고 있습니다.</p><p>API 정상화 후 실제 게시글이 다시 노출됩니다.</p>",
};

const CommuCtntCtxtUi = ({gameSvcCd,ctntKindCd,ctntPstdSno}:any) => {
    const {gameMainPageData, langData}:any = useOutletContext();
    const navigate = useNavigate();
    const location= useLocation();  
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    const test =() => {
    }
    let query =serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd");
    let getCtntKindCd = query.get("ctntKindCd");
    let getctntPstdSno = query.get("ctntSno");
    let getPageState = query.get("pageState");
    if(getGameSvcCd !=null){
        gameSvcCd = getGameSvcCd;
        ctntKindCd = getCtntKindCd;
        ctntPstdSno = getctntPstdSno;
    }

    if(gameSvcCd ==null) {
        gameSvcCd = location.state?.gameSvcCd;
    }
    if(ctntKindCd ==null) {
        ctntKindCd = location.state?.ctntKindCd;
    }

    const returnUrl = location.state?.returnUrl || "";
    const returnUrlParams = new URLSearchParams(String(returnUrl).split("?")[1] || "");
    const currentSearchParams = new URLSearchParams(location.search);
    const currentBoardCode = currentSearchParams.get("ctntKindCd") || getCtntKindCd || ctntKindCd || "";
    const currentSubCode = currentSearchParams.get("ctntCtgrCd") || returnUrlParams.get("ctntCtgrCd") || "";

    const [ctntKindCdState,setctntKindCdState] = useState(currentBoardCode);
    const [ctntPstdCtxtState,setctntPstdCtxtState] = useState<any>();
    const [ctntPstdTitlState,setctntPstdTitlState] = useState<any>();
    const [aplyStrtDtimeState,setAplyStrtDtimeState] = useState<any>();
    const [ctntTitlState,setCtntTitlState] = useState("");
    const [vwrCntState,setVwrCntState] = useState<any>();
    const [isMobileCategoryOpen, setIsMobileCategoryOpen] = useState(false);
    const [boardCtgrTree, setBoardCtgrTree] = useState<CommuBrdCtgrNode[]>([]);
    const [expandedCategory, setExpandedCategory] = useState<string>(currentBoardCode);
    const selectedCategoryLabel = boardCtgrTree.find((m) => m.ctgrCd === currentBoardCode)?.ctgrNm || "카테고리";
    const applyDummyPostData = () => {
        setctntPstdTitlState(DUMMY_POST_DATA.brdPstdTitl);
        setAplyStrtDtimeState(DUMMY_POST_DATA.crtdDtime);
        setVwrCntState(DUMMY_POST_DATA.brdPstdReadCnt);
        setctntPstdCtxtState(DUMMY_POST_DATA.brdPstdCtxt);
    };
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null); 
    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };
    let test1:any;

    useEffect(()=>{
        if (!langData || !ctntKindCdState) return;
        if (!getctntPstdSno) {
            applyDummyPostData();
            return;
        }
        CommuBrdPstdCtntApi(ctntKindCdState,getctntPstdSno,currentBoardCode)
        .then((Resp) => {
            if(Resp.apiHdr.code !="MEMB0000") {
                applyDummyPostData();
                return;
            }
            setctntPstdTitlState(Resp.apiBody.brdPstdTitl);
            setAplyStrtDtimeState(Resp.apiBody.crtdDtime);
            setVwrCntState(Resp.apiBody.brdPstdReadCnt);
            setctntPstdCtxtState(Resp.apiBody.brdPstdCtxt);
            switch(ctntKindCdState){
                case "PNOT":
                    setCtntTitlState(langData?.GAME_SVC_PNOT_LST_TITL_00);
                break;
                case "UPDT":
                    setCtntTitlState(langData?.GAME_SVC_UPDT_LST_TITL_00);
                break;
                case "EVNT":
                    setCtntTitlState(langData?.GAME_SVC_EVNT_LST_TITL_00);
                break;
                case "DVNT":
                    setCtntTitlState(langData?.GAME_SVC_DVNT_PAGE_TITL_00);
                break;
            }
        })
        .catch((Err) => {
            console.error(Err);
            applyDummyPostData();
        });
    },[MgpStore.getState().LangSetState.Lang, langData]);

    useEffect(() => {
        CommuBrdCtgrLstApi()
            .then((Resp:any) => {
                if (Resp?.apiHdr?.code !== "COMM0000") {
                    setBoardCtgrTree([]);
                    return;
                }
                setBoardCtgrTree(Resp?.apiBody?.ctgrLst || []);
            })
            .catch(() => {
                setBoardCtgrTree([]);
            });
    }, [MgpStore.getState().LangSetState.Lang]);

    useEffect(() => {
        if (!boardCtgrTree.length) return;
        const matchedBoard = boardCtgrTree.find((item) => item.ctgrCd === currentBoardCode) || boardCtgrTree[0];
        setExpandedCategory(matchedBoard.ctgrCd);
    }, [boardCtgrTree, currentBoardCode]);

    // 모바일 카테고리 메뉴 열림 시 body 스크롤 방지
    useEffect(() => {
        if (isMobileCategoryOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isMobileCategoryOpen]);
   const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };

    const handleCategorySelect = (boardCode: string) => {
        const selectedBoard = boardCtgrTree.find((item) => item.ctgrCd === boardCode);
        if (!selectedBoard) return;

        setExpandedCategory(boardCode);
        const firstSubCode = selectedBoard.children?.[0]
            ? (selectedBoard.children[0].subCtgrCd || selectedBoard.children[0].ctgrCd)
            : "";
        const params = new URLSearchParams();
        params.set("gameSvcCd", gameSvcCd || getGameSvcCd || "BBO");
        params.set("ctntKindCd", boardCode);
        if (firstSubCode) {
            params.set("ctntCtgrCd", firstSubCode);
        }
        params.set("page", "1");
        navigate(`/community/Lst?${params.toString()}`);
    };

    const handleSubMenuSelect = (boardCode: string, subCode: string) => {
        const params = new URLSearchParams();
        params.set("gameSvcCd", gameSvcCd || getGameSvcCd || "BBO");
        params.set("ctntKindCd", boardCode);
        params.set("ctntCtgrCd", subCode);
        params.set("page", "1");
        navigate(`/community/Lst?${params.toString()}`);
    };
   
    return(
        <>
        <ApiResultModal
                    open={resultModalOpen}
                    message={resultModalMessage}
                    onClose={closeResultModal}
        confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
                />
        <div className="BgW">
            <GamePageBanner gameMainPageData={gameMainPageData} langData={langData} />
            <div className="container1580 mt30">
                <CommuCategoryLayout
                    isMobileCategoryOpen={isMobileCategoryOpen}
                    selectedCategoryLabel={selectedCategoryLabel}
                    title={(
                        <a href="/GamePage/Ctnt/CtntLst?gameSvcCd=BBO&ctntKindCd=PNOT" className="ctntCtgrTitlTxtLink">
                            NEWS
                        </a>
                    )}
                    categories={boardCtgrTree}
                    expandedCategory={expandedCategory}
                    activeBoardCode={currentBoardCode}
                    activeSubCode={currentSubCode}
                    onToggleMobileCategory={() => setIsMobileCategoryOpen(!isMobileCategoryOpen)}
                    onCloseMobileCategory={() => setIsMobileCategoryOpen(false)}
                    onCategorySelect={handleCategorySelect}
                    onSubMenuSelect={handleSubMenuSelect}
                >
                    <div className="faqCtxtLstWrap">
                            <div className="trmsContainer">
                                <div className="ctntCtgr">
                                    <h1 className="ctntCtgrTitl">{ctntTitlState&&ctntTitlState}</h1>
                                </div>
                                <div className="trmsCtxtWrap">
                                    <div className="ctntTitlWrap">
                                        <h1>{ctntPstdTitlState}</h1>
                                        <div className="dFlex gap10 alignCenter">
                                            <p>{aplyStrtDtimeState}</p>
                                            <p className="vwrCnt"><i className="eye"></i>{vwrCntState}</p>
                                        </div>
                                    </div>
                                    {ctntPstdCtxtState != null?
                                        <div className="trmsCtxt ctntCtxt gamePageCtntCtxt" 
                                            dangerouslySetInnerHTML={{ __html: ctntPstdCtxtState }}
                    
                                        />
                                    : null}
                                </div>
                                <CommuCmntWriteUi brdCd={ctntKindCdState} brdPstdSno={ctntPstdSno} />
                                <CommuCmntUi gameSvcCd={gameSvcCd} brdCd={ctntKindCdState} brdPstdSno={ctntPstdSno} />
                                <div className="ctntBtnWrap">
                                    <Link to={location.state?.returnUrl || `/GamePage/Ctnt/CtntLst?gameSvcCd=${getGameSvcCd}&ctntKindCd=${getCtntKindCd}&lang=${MgpStore.getState().LangSetState.Lang}&page=1`}>
                                        <p>{langData&&langData.GAME_SVC_COMM_LST_BTN_00}</p>
                                    </Link>
                                </div>
                            </div>
                    </div>
                </CommuCategoryLayout>
            </div>
        </div>
        </>
    )
}

export default CommuCtntCtxtUi;
